import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import Loading from '../../components/Loading';

const LiveCallPage = lazy(
  () => import(/* webpackChunkName: "live-call" */ '../../pages/live-call/'),
);

export const liveRouter = (
  <Route
    path="/live-call/:dasId"
    element={
      <Suspense fallback={<Loading />}>
        <LiveCallPage />
      </Suspense>
    }
  />
);

export default liveRouter;
